import { EXPERIMENTS, EXPERIMENTS_DECISIONS } from 'Services/optimizely/optimizely.consts';

import { useOptimizelyDecision } from '../useOptimizelyDecision';

interface UseDealerDashboardExperimentation {
	dealerDashboardDecision: Nullable<string>;
	isDealerDashboardEnabled: boolean;
}

const INVALID_EXPERIMENT_DECISIONS: Array<string | null> = [EXPERIMENTS_DECISIONS.DEALER_DASHBOARD.off, null];

export const useDealerDashboardExperimentation = (): UseDealerDashboardExperimentation => {
	const { decision, isEnabled } = useOptimizelyDecision({
		experimentId: EXPERIMENTS.DEALER_DASHBOARD,
	});

	const isValidDecision = Boolean(decision && isEnabled && !INVALID_EXPERIMENT_DECISIONS.includes(decision));

	return {
		dealerDashboardDecision: decision,
		isDealerDashboardEnabled: isValidDecision,
	};
};
